import { Box, type BoxProps, Text } from '@mantine/core'

import { useDocumentState } from '../../../booking-documents/hooks/useDocumentState'
import { SectionTable } from './SectionTable'

export type SectionTermsAndConditionsProps = BoxProps

export function SectionTermsAndConditions({
  ...props
}: SectionTermsAndConditionsProps) {
  const { documentPreview, translate } = useDocumentState()

  return (
    documentPreview?.booking_settings
      ?.documents_contract_include_terms_and_conditions &&
    documentPreview.owner?.terms_and_conditions && (
      <SectionTable {...props}>
        <SectionTable.Header>
          <Text fw={500} size='md'>
            {translate?.('label_terms_and_conditions')}
          </Text>
        </SectionTable.Header>
        <SectionTable.Body>
          <Box
            dangerouslySetInnerHTML={{
              __html: String(documentPreview?.owner?.terms_and_conditions),
            }}
            style={{ fontSize: '12px' }}
          />
        </SectionTable.Body>
      </SectionTable>
    )
  )
}
